
import Vue from 'vue';

export default Vue.extend({
  name: 'Banner',
  methods: {
    goSignup() {
      this.$router.push('/cqcc/signup').catch((err: Error) => err);
    },
  },
});
